import { render, staticRenderFns } from "./PdfThumbnail.vue?vue&type=template&id=07fa5a1e&"
import script from "./PdfThumbnail.vue?vue&type=script&lang=js&"
export * from "./PdfThumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports